const NitroClusterPin = (type: string, count: number, disabled?: boolean) => {
  let label = count.toString();

  if (count >= 99) {
    label = "99+";
  } else if (count >= 90) {
    label = "90+";
  } else if (count >= 80) {
    label = "80+";
  } else if (count >= 70) {
    label = "70+";
  } else if (count >= 60) {
    label = "60+";
  } else if (count >= 50) {
    label = "50+";
  } else if (count >= 40) {
    label = "40+";
  } else if (count >= 30) {
    label = "30+";
  } else if (count >= 20) {
    label = "20+";
  } else if (count >= 10) {
    label = "10+";
  } else if (count >= 5) {
    label = "5+";
  }

  let color = "#383838";
  switch (type) {
    case "koch":
      color = "#148DD3";
      break;
    case "customer":
      color = "#8C12D8";
      break;
    case "competitor":
      color = "#C52F00";
      break;
    case "zipCodes":
      color = "#ababab";
      break;
    case "kochAndCompetitor":
      color = "url(#gradient2)";
      break;
    default:
      color = "#383838";
      break;
  }

  return new DOMParser().parseFromString(
    `<svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg" style="${
      disabled ? "opacity: 30%" : ""
    }">
      <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop
          offset="0%"
          style="stop-color: '#148DD3'; stop-opacity: 1"
        />

        <stop
          offset="50%"
          style="stop-color: '#148DD3'; stop-opacity: 1"
        />
        <stop
          offset="50%"
          style="stop-color: '#C52F00'; stop-opacity: 1"
        />
        <stop
          offset="100%"
          style="stop-color: '#C52F00'; stop-opacity: 1"
        />
      </linearGradient>

      <circle cx="31.5" cy="24.5" r="9.5" />

      <path
      d="M31.5005 5.25049C25.9671 5.25021 20.6573 7.43386 16.725 11.3268C12.7927 15.2198 10.5558 20.5074 10.5005 26.0405C10.5005 40.4255 29.0067 56.438 29.7942 57.1205C30.2697 57.5272 30.8748 57.7507 31.5005 57.7507C32.1262 57.7507 32.7313 57.5272 33.2067 57.1205C34.1255 56.438 52.5005 40.4255 52.5005 26.0405C52.4452 20.5074 50.2083 15.2198 46.276 11.3268C42.3437 7.43386 37.0338 5.25021 31.5005 5.25049ZM31.5005 34.1255C29.6834 34.1255 27.9071 33.5867 26.3962 32.5771C24.8853 31.5676 23.7077 30.1327 23.0123 28.4539C22.317 26.7751 22.135 24.9278 22.4895 23.1456C22.844 21.3634 23.7191 19.7263 25.0039 18.4414C26.2888 17.1566 27.9259 16.2815 29.7081 15.927C31.4903 15.5725 33.3376 15.7545 35.0164 16.4498C36.6952 17.1452 38.1301 18.3228 39.1396 19.8337C40.1492 21.3446 40.688 23.1209 40.688 24.938C40.688 27.3747 39.72 29.7115 37.997 31.4345C36.274 33.1575 33.9372 34.1255 31.5005 34.1255Z"
      fill="${color}"
      />
      <rect x="13.5" y="8" width="36" height="29" rx="13" fill="${color}"  />
      <text x="50%" y="35" text-anchor="middle" fill="white" font-size="20">${label}</text>
  </svg>`,
    "image/svg+xml"
  ).documentElement;
};

export default NitroClusterPin;
